import { useMatch } from 'react-router-dom';
import { useShift } from '../contexts/ShiftContext';
import { HoldToRecordButton, useHoldToRecord } from '../contexts/HoldToRecordContext';
import { useSession } from '../contexts/SessionContext';
import { getDocumentationNoteType } from '../utils/taskDocumentation';

export default function RecordFAB() {
  const { isOnShift } = useShift();
  const { overlayOpen } = useHoldToRecord();
  const { taskDocSession, submitTaskDocTranscript } = useSession();
  const patientMatch = useMatch({ path: '/patients/:id', end: false });
  const patientId = patientMatch?.params?.id || null;

  if (!isOnShift) return null;

  // Only intercept while the task-doc modal is actually open on this patient.
  // Soft-closed sessions (open: false) must not steal free recordings.
  const taskDocOpen = Boolean(
    taskDocSession?.open === true
    && taskDocSession?.taskId
    && taskDocSession?.patientId
    && (!patientId || patientId === taskDocSession.patientId)
  );
  const holdOptions = taskDocOpen
    ? {
        manualTaskCompletionTaskId: taskDocSession.taskId,
        manualTaskCompletionType: getDocumentationNoteType(taskDocSession.task),
        onTranscript: (transcript) => submitTaskDocTranscript(transcript),
      }
    : null;

  return (
    <HoldToRecordButton
      patientId={patientId || (taskDocOpen ? taskDocSession.patientId : null)}
      size="fab"
      holdOptions={holdOptions}
      className={`${overlayOpen ? 'opacity-0' : ''} ${
        // Stay above the recording overlay so release still hits this button if capture drops.
        overlayOpen || taskDocOpen ? 'z-[240]' : ''
      }`}
    />
  );
}
